export const environment = process.env.VUE_APP_ENVIRONMENT
